import { useState, useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import useGetEnabledPromoTypes from './useGetEnabledPromoTypes';
import { useDesignStore } from '../store/design/context';
import {
  useGroupedPromoStore
} from '../store/index';
import { getPromoEligibleItemsInDesign } from '../utils/promo-utils';

export const useGroupedPromotions = () => {

  const enabledPromoTypes = useGetEnabledPromoTypes();

  const [result, setResult] = useState({ promoEligibleItemsInDesign: {}, enabledPromoTypes });

  const allPromoProducts = useGroupedPromoStore((state) => state.allPromoProducts);

  const design = useDesignStore((state) => state.design);

  useEffect(() => {

    const promoEligibleItemsInDesign = getPromoEligibleItemsInDesign(
      design,
      allPromoProducts,
      enabledPromoTypes
    );

    setResult({ promoEligibleItemsInDesign, enabledPromoTypes });

  }, [design, enabledPromoTypes, allPromoProducts]);

  return result;
};
